import Table from './Table';
import CellWithDeletedStatus from './CellWithDeletedStatus';
import CellWithMultiple from './CellWithMultiple';

export {
    CellWithDeletedStatus,
    CellWithMultiple
};


export default Table;
